<template>
	<div class="widget-card">
		<h2 v-if="widget" class="text-center">{{ widget.dashboardwidgets_title }}</h2>

		<LoadingSpinner v-if="loading" />
		<b-table
			v-else-if="tableItems.length > 0"
			:items="tableItems"
			:fields="fields"
			small
			bordered
		>
			<template #cell(code)="{ value }">
				<span class="d-block text-center">{{ $t('acte.' + value) }}</span>
			</template>
			<template #cell(value)="{ value, item }">
				<a href="" class="d-block text-center" @click.prevent="goToPlanning(item)">{{ value }}</a>
			</template>
		</b-table>
		<span v-else class="d-block text-center">{{ $t('cards.widget.actes_en_retard_empty') }}</span>
	</div>
</template>

<script type="text/javascript">
import DashboardMixin from '@/mixins/Dashboard.js'

export default {
	name: 'WidgetUndoneActs',
	mixins: [DashboardMixin],
	props: ['widget'],
	data() {
		return {
			loading: true,
			tableItems: [],
			fields: [
				{ key: 'code', label: this.$t('cards.widget.col_acte_group') },
				{ key: 'value', label: this.$t('cards.widget.col_undone_count') },
			],
		}
	},

	mounted() {
		this.loadData()
	},

	methods: {
		async loadData() {
			this.loading = true
			// L'API renvoie { code, value } par groupe d'acte (uniquement ceux ayant
			// au moins un acte en retard). Le code est traduit dans le template.
			this.tableItems = await this.getUndoneActsStats()
			this.loading = false
		},

		goToPlanning(item) {
			const tab = this.$t('actes_groupe.' + item.code)
			// Redirige vers Actes > Planning, sur l'onglet du groupe d'acte. La date "late"
			// borne le planning aux actes en retard (début = null, fin = aujourd'hui).
			this.$router.push('/planning/t=' + encodeURIComponent(tab) + '/d=late')
		},
	},

	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	},
}
</script>
